export const allowedChars = '0123456789+-.,';
